<template>
  <v-tooltip top open-on-hover :open-delay="500">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        icon
        v-bind="attrs"
        v-on="on"
        @click.stop="smartFavoriteSwitch(voicemail)"
      >
        <v-icon>{{ voicemail.favoriteIcon }}</v-icon>
      </v-btn>
    </template>
    <span>{{ $t('vmail.tip.addToFavorites') }}</span>
  </v-tooltip>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'voicemail-msgs-table-favorite-column',
  props: {
    voicemail: {
      type: Object,
      required: true
    }
  },
  methods: {
    ...mapActions({
      smartFavoriteSwitch: 'voicemails/smartFavoriteSwitch'
    })
  }
}
</script>

<style scoped>
</style>
